export const clear = (node) => {
  while (node.firstChild) {
    node.removeChild(node.firstChild);
  }
};

export const repaint = (node) => {
  // eslint-disable-next-line no-void
  void (node.offsetHeight);
};

export default {
  clear,
  repaint,
};
